
import React from "react"
import * as styles from "./ContactUs.module.scss"
import { useIntl } from "gatsby-plugin-intl"
import WhatsApp from "../../../assets/images/icons/whatsapp-icon.svg"
import ContactForm from "../../UI/ContactForm/ContactForm"
import Phone from "../../../assets/images/icons/phone-icon.svg"
import Mail from "../../../assets/images/icons/mail-icon.svg"

const ContactUs: React.FC = () => {
	const intl = useIntl()

	const contactLinks = [
		{
			title: "sales@invenpro.tech",
			img: Mail,
			link: "mailto:sales@invenpro.tech",
		},
		{
			title: "+971 58 595 1846",
			img: Phone,
			link: "tel:+971585951846",
		},
		{
			title: "WhatsApp",
			img: WhatsApp,
			link: "https://wa.me/+971585951846",
		},

	]


	return (
		<section className={styles.contactUs}>

			<div className={styles.contactUsTitleBlock}>
				<h2>
					{intl.formatMessage({ id: "contact-form.title" })}
				</h2>
				<p>
					{intl.formatMessage({ id: "contact-form.text" })}
				</p>
			</div>
			<ContactForm className={styles.contactUsForm} />
			<ul className={styles.contactList}>
				{
					contactLinks.map((item, index) => (
						<li key={index} className={styles.contactItem}>
							<a href={item.link}>
								<img src={item.img} alt={item.title} width={48} height={48} />
								{item.title}
							</a>
						</li>
					))
				}
			</ul>
		</section>
	)
}

export default ContactUs
